import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useEffect, useRef, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { useToast } from '../../../../../Shared/hook/useToast';
import { PromoBar } from '../../../Domain/Model/PromoBar/PromoBar';
import OffersPromoViewModel from '../OffersPromoViewModel';

export const PromoBarItemDetailFormView = () => {

    const [webImage, setWebImage] = useState<File | null>(null);
    const [mobileImage, setMobileImage] = useState<File | null>(null);


    const [originalWebName, setOriginalWebName] = useState<string>("");
    const [originalMobileName, setOriginalMobileName] = useState<string>("");
    

    // const [listObtained, setListObtained] = useState<Products[]>([]);
    // const [productObtained, setProductObtained] = useState<Product | undefined>(
    //     {
    //         productId: 0,
    //         productName: "",
    //         mainImage: "",
    //         salePrice: 0,
    //         discountPrice: 0,
    //     }
    // );
    const [isDraggingWeb, setIsDraggingWeb] = useState(false);
    const [isDraggingMobile, setIsDraggingMobile] = useState(false);

    const webInputRef = useRef<HTMLInputElement>(null);
    const mobileInputRef = useRef<HTMLInputElement>(null);

    const [isListProduct, setIsListProduct] = useState(true);

    const [banerType, setBanerType] = useState(0);
    

    const [totalItems, setTotalItems] = useState(0);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [pageSize, setPageSize] = useState(10);

    const [selectedProducts, setSelectedProducts] = useState<Number[]>([]);
    const [delectedProducts, setDelectedProducts] = useState<Number[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<number>(0);

    const navigate = useNavigate();

    const title = "Detalle de cintillo";
    const { id } = useParams();
    const { showSuccess, showError, showWarn, showInfo } = useToast();

    const {
            getPromoBarById,
            updatePromoBar
          } = OffersPromoViewModel();

   
//    const loadProducts = async (page: number, size: number, search: string = '') => {
//         const result = await getProducts(page, size, search);
//         setTotalItems(result.totalCount);
//     };

    const fetchAndSetImage = async () => {
        try {
             const data = await getPromoBarById(Number(id)) as PromoBar;

             if (data) {
            console.log(data);
            }
            
            if (!data) {
                throw new Error("No se encontraron datos del producto");
            }

            if (!data.imagePrimary || !data.imageSecondary) {
                throw new Error("Faltan URLs de imágenes en los datos recibidos");
            }

            const { nameImage: namePrimary, mimeType: mimePrimary } = getNameAndMimeFromFilename(data.imagePrimary);
            const { nameImage: nameSecondary, mimeType: mimeSecondary } = getNameAndMimeFromFilename(data.imageSecondary);

            const [fileweb, filemobile] = await Promise.all([
            data.imagePrimary
                ? urlToFile(
                    data.imagePrimary,
                    `${namePrimary}.${mimePrimary.split("/")[1]}`,
                    mimePrimary
                )
                : null,
            data.imageSecondary
                ? urlToFile(
                    data.imageSecondary,
                    `${nameSecondary}.${mimeSecondary.split("/")[1]}`,
                    mimeSecondary
                )
                : null
            ]);

            if (!fileweb || !filemobile) {
                throw new Error("Error al convertir las imágenes");
            }

            // if(!data.products) {
            //     throw new Error("Error al obtener productos");
            // }

            setWebImage(fileweb);
            setMobileImage(filemobile);

            setOriginalWebName(fileweb.name);
            setOriginalMobileName(filemobile.name);

            // setListObtained(data.products);

            // setBanerType(data.type);
            // setProductObtained(data.product);
           

        } catch (error) {
            console.error("Error en fetchAndSetImage:", error);
            showError('Error','No se pudieron cargar las imágenes del banner');
        }
    };

    function getNameAndMimeFromFilename(filename: string = "") {
        const parts = filename.split(".");
        if (parts.length < 2) {
            throw new Error("El nombre de archivo no tiene extensión");
        }
        
        const ext = parts.pop()?.toLowerCase();
        const nameImage = parts.join(".");
        
        const mimeTypes: Record<string, string> = {
            png: "image/png",
            jpg: "image/jpeg",
            jpeg: "image/jpeg",
            gif: "image/gif",
            webp: "image/webp"
        };
        
        const mimeType = mimeTypes[ext || ""] || "application/octet-stream";
        
        return { nameImage, ext, mimeType };
    }

    const urlToFile = async (url: string, filename: string, mimeType: string): Promise<File> => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            return new File([blob], filename, { type: mimeType });
        } catch (error) {
            console.error(`Error al convertir URL a File: ${url}`, error);
            throw error;
        }
    };


    useEffect(() => {

        // console.log("Products", products);

        // loadProducts(page, pageSize, search); 
    }, [page, pageSize, search]);

    useEffect(() => {
        if (id) {
            fetchAndSetImage();
        }
    }, [id]);

    // useEffect(() => {
    //     console.log("selectedProducts", selectedProducts);
    //     console.log("delectedProducts", delectedProducts);
        
    // }, [selectedProducts, delectedProducts]);

    //  useEffect(() => {
    //     console.log("selectedProduct", selectedProduct);
        
    // }, [selectedProduct]);

    


    const handleDrop = (e: React.DragEvent<HTMLDivElement>, type: "web" | "mobile") => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file && file.type.startsWith("image/")) {
          type === "web" ? setWebImage(file) : setMobileImage(file);
        }
      };
    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, type: "web" | "mobile") => {
        const file = e.target.files?.[0];
        if (file) {
            type === "web" ? setWebImage(file) : setMobileImage(file);
        }
    };


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const formData = new FormData();

        if (webImage && webImage.name !== originalWebName) {
            formData.append("ImagePrimary", webImage);
        }

        if (mobileImage && mobileImage.name !== originalMobileName) {
            formData.append("ImageSecondary", mobileImage);
        }

        console.log("Preparando envío...");

        let responseOk:any = false;

        responseOk = await updatePromoBar(Number(id), formData);

        // if (selectedProducts.length > 0) {

        //     selectedProducts.forEach((idPro: Number) =>
        //         formData.append('ProductsToAdd[]', idPro.toString())
        //     );

        //     delectedProducts?.forEach((idPro: Number) =>
        //         formData.append('DetailsToRemove[]', idPro.toString())
        //     );

        //     responseOk = await updatePromoBarList(Number(id), formData);
        // }

        // else if (selectedProduct > 0) {
        //     formData.append('ProductId', selectedProduct.toString());
        //     responseOk = await updatePromoBarSingle(Number(id), formData);
        // }

        // else {
        //     showError("Formulario incompleto", "Debe elegir al menos un producto.");
        //     return;
        // }

        for (const pair of formData.entries()) {
            console.log(`${pair[0]}:`, pair[1]);
        }

        if (responseOk === true) {
            showSuccess("Actualizado", "Se actualizó con éxito!");
            setTimeout(() => navigate(`/promo-bar-form`), 3000);
        } else {
            showError("Error al actualizar", "No se pudo actualizar!");
        }
    };

    return(
        <>
        <div className='container-fluid'>
            <div className="block-header">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                        <h2>Ofertas y promociones</h2>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                            </li>
                            <li className="breadcrumb-item">
                                <a href="/offers-promotions" className="text-danger">Ofertas y promociones</a>
                            </li>
                            <li className="breadcrumb-item">
                                <a href="/promo-bar-form" className="text-danger">Lista de cintillo</a>
                            </li>
                            <li className="breadcrumb-item">{title}</li>
                        </ul>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-flex flex-row-reverse">
                            
                            <div className="p-2 d-flex">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='title-report'>
                    {title}
                </div>
            </div>
            <div className='row'>
                <div className='col-lg-12'>
                    <div className="card p-3">
                        <form onSubmit={handleSubmit} encType="multipart/form-data" className="form-container">
                            <div
                            className={`dropzone ${isDraggingWeb ? 'drag-over-web' : ''}`}
                            onClick={() => webInputRef.current?.click()}
                            onDrop={(e) => {
                                handleDrop(e, "web");
                                setIsDraggingWeb(false);
                            }}
                            onDragOver={(e) => e.preventDefault()}
                            onDragEnter={() => setIsDraggingWeb(true)}
                            onDragLeave={() => setIsDraggingWeb(false)}
                            >
                            {webImage ? (
                                <img src={URL.createObjectURL(webImage)} alt="web banner" />
                            ) : (
                                <>
                                <p className="size-banner">530 X 550</p>
                                <span>Haz clic o arrastra aquí (PromoBar Web)</span>
                                <span>solo valido (PNG,JPG,JPEG)</span>
                                </>
                            )}
                            <input
                                ref={webInputRef}
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                onChange={(e) => handleChange(e, "web")}
                            />
                            </div>

                            <div
                            className={`dropzone ${isDraggingMobile ? 'drag-over-mobile' : ''}`}
                            onClick={() => mobileInputRef.current?.click()}
                            onDrop={(e) => {
                                handleDrop(e, "mobile");
                                setIsDraggingMobile(false);
                            }}
                            onDragOver={(e) => e.preventDefault()}
                            onDragEnter={() => setIsDraggingMobile(true)}
                            onDragLeave={() => setIsDraggingMobile(false)}
                            >
                            {mobileImage ? (
                                <img src={URL.createObjectURL(mobileImage)} alt="mobile banner" />
                            ) : (
                                <>
                                <p className="size-banner">1500 X 787</p>
                                <span>Haz clic o arrastra aquí (PromoBar Móvil)</span>
                                <span>solo valido (PNG,JPG,JPEG)</span>
                                </>
                            )}
                            <input
                                ref={mobileInputRef}
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                onChange={(e) => handleChange(e, "mobile")}
                            />
                            </div>
                            <div className='btn-float-content'>
                                <button type="submit" className="btn btn-dark">Guardar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* <div className='row mt-3'>
                <div className='col-lg-12 content-btn-options mb-2'>
                    {banerType===1 && (
                            <>
                                <h3>Seleccione un producto</h3>
                            </>
                    )}
                    {banerType===2 && (
                            <>
                                <h3>Seleccione Productos</h3>
                            </>
                    )}
                    {banerType===3 && (
                            <>
                                <button className={`btn btn-dark ${isListProduct ? "is-list-product": ""}`} onClick={()=>setIsListProduct(true)} >Añadir Productos</button>
                                <button className={`btn btn-dark ${!isListProduct ? "is-list-product": ""}`} onClick={()=>{setIsListProduct(false)}} >Añadir URL de un producto</button>
                            </>
                    )}
                </div>
                <div className='col-lg-12'>
                    <div  className="card pt-3">
                        
                        {banerType===1 && (
                            <CustomOrderList
                            data={products}
                            pageSize={10}
                            sourceSearchValue={search}
                            sourcePage={page + 1}
                            sourceTotalCount={totalItems}
                            onSourceSearchChange={(value) => {
                                setSearch(value);
                                setPage(0);
                                loadProducts(0, 5, value);
                            }}
                            onSourcePageChange={(newPage) => {
                                setPage(newPage - 1);
                                loadProducts(newPage - 1, 5, search);
                            }}
                            onChange={(id) => {
                                setSelectedProduct(id);
                            }}
                            ProductObtained={productObtained}
                        />
                        )}
                        {banerType===2 && (
                                
                        <CustomPickList
                            data={products}
                            pageSize={10}
                            sourceSearchValue={search}
                            sourcePage={page + 1}
                            sourceTotalCount={totalItems}
                            onSourceSearchChange={(value) => {
                                setSearch(value);
                                setPage(0);
                                loadProducts(0, 5, value);
                            }}
                            onSourcePageChange={(newPage) => {
                                setPage(newPage - 1);
                                loadProducts(newPage - 1, 5, search);
                            }}
                            onChange={(selectedIds, deletedIds) => {
                                setSelectedProducts(selectedIds);
                                setDelectedProducts(deletedIds);
                            }}
                            listObtained={listObtained}
                        />
                        )}

                        {banerType===3 && (
                            <>
                                    {isListProduct && (
                                    <CustomPickList
                                        data={products}
                                        pageSize={10}
                                        sourceSearchValue={search}
                                        sourcePage={page + 1}
                                        sourceTotalCount={totalItems}
                                        onSourceSearchChange={(value) => {
                                            setSearch(value);
                                            setPage(0);
                                            loadProducts(0, 5, value);
                                        }}
                                        onSourcePageChange={(newPage) => {
                                            setPage(newPage - 1);
                                            loadProducts(newPage - 1, 5, search);
                                        }}
                                        onChange={(selectedIds, deletedIds) => {
                                            setSelectedProducts(selectedIds);
                                            setDelectedProducts(deletedIds);
                                        }}
                                        listObtained={listObtained}
                                    />
                                )}
                                {!isListProduct && (
                                    <CustomOrderList
                                        data={products}
                                        pageSize={10}
                                        sourceSearchValue={search}
                                        sourcePage={page + 1}
                                        sourceTotalCount={totalItems}
                                        onSourceSearchChange={(value) => {
                                            setSearch(value);
                                            setPage(0);
                                            loadProducts(0, 5, value);
                                        }}
                                        onSourcePageChange={(newPage) => {
                                            setPage(newPage - 1);
                                            loadProducts(newPage - 1, 5, search);
                                        }}
                                        onChange={(id) => {
                                            setSelectedProduct(id);
                                        }}
                                        ProductObtained={productObtained}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div> */}
        </div>
        </>
    );
}